/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import DOMPurify from 'dompurify';
import { makeStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '1rem',
    marginBottom: '2rem',
    [theme.breakpoints.up('xl2')]: {
      '&.MuiTypography-body1': {
        width: '100%',
      },
    },
  },
}));

const DescriptionField = ({ description, schema, variant }) => {
  const classes = useStyles();

  const descriptionToDisplay = schema?.description ? schema.description : description;

  const config = {
    ADD_ATTR: ['target'],
  };

  if (descriptionToDisplay) {
    return (
      <Typography
        variant={variant}
        className={classes.root}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(descriptionToDisplay, config) }}
      />
    );
  }
  return null;
};

export default DescriptionField;
